if ($( document ).width() > 700) {
    $('ul.nav').on('click', 'a[data-toggle="custom-collapse"]', function(e) {
        e.preventDefault();
        var menu = $("#menu");

        // Fermé donc action d'ouvrir ou de changer de menu
        if ($(this).hasClass('collapsed')) {

            $('.second:not(.collapse)').toggleClass('collapse');
            $($(this).data('submenu')).toggleClass('collapse');

            $('a[data-toggle="custom-collapse"]:not(.collapsed)').addClass('collapsed');
            $(this).removeClass('collapsed');
            menu.collapse('show');

        // Ouvert donc action de fermer
        } else {
            if (menu.attr('aria-expanded') === 'true') {
                menu.collapse('hide');
            }
        }
    });

}

$(function() {
  $('#menu').on('hidden.bs.collapse', function () {
      $('a[data-toggle="custom-collapse"]:not(.collapsed)').addClass('collapsed');
  });
});

document.addEventListener('DOMContentLoaded', function () {
    var taxModeButton = document.getElementById('toggle-tax-mode');
    if (taxModeButton) {
        taxModeButton.addEventListener('change', function(event) {
            var tax = event.target.checked ? 'HT' : 'TTC';
            var taxClass = event.target.checked ? 'show-tax-ht-body' : 'show-tax-ttc-body';

            document.body.classList.remove('show-tax-ttc-body', 'show-tax-ht-body');
            document.body.classList.add(taxClass);

            var url = window.Routing.generate('arberi_tax_mode', {
                mode: tax,
                _locale: document.documentElement.lang
            });

            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    try {
                        var data = JSON.parse(xhr.responseText);
                        console.log('Tax mode updated:', data.tax_mode);
                    } catch (e) {
                        console.error('Failed to parse response:', e);
                    }
                }
            };
            xhr.send();
        });
    }
});